import {
  useFloating,
  offset,
  shift,
  flip,
  autoUpdate,
  FloatingPortal,
  FloatingOverlay,
  size,
} from '@floating-ui/react';

import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';
import { Props } from './types';

export const ChangePagePopover = ({ onClose, onReset, onKeep, anchorEl }: Props) => {
  const { refs, floatingStyles } = useFloating({
    open: true,
    middleware: [
      offset(10),
      flip(),
      shift(),
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`,
          });
        },
      }),
    ],
    placement: 'bottom',
    elements: {
      reference: anchorEl,
    },
    whileElementsMounted: autoUpdate,
  });

  return (
    <FloatingPortal>
      <FloatingOverlay className={s.tooltipOverlay} onClick={onClose} />
      <div ref={refs.setFloating} style={floatingStyles} className={s.wrapper} onClick={(e) => e.stopPropagation()}>
        <div className={s.headerContainer}>
          <Text type="brandon" weight="500" className={s.header}>
            Switching content page?
          </Text>
        </div>
        <Text type="brandon" size="medium" className={s.description}>
          Some of the fields below were already filled in for the previous page. Would you like to keep that
          information?
        </Text>
        <div className={s.buttonGroup}>
          <Button onClick={onReset} type="default" size="small" htmlType="button" className={s.button}>
            Don't Keep
          </Button>
          <Button onClick={onKeep} type="primary2" size="small" htmlType="button" className={s.button}>
            Keep
          </Button>
        </div>
      </div>
    </FloatingPortal>
  );
};
